import Headroom from 'headroom.js';
import { findMany, fire } from '../helpers';
import './style.pcss'

findMany('header.sticky').forEach(element => {
    new Headroom(element, {
        offset: element.clientHeight,
        onUnpin: () => {
            fire('dropdown-close');
            fire('sticky-sidebars::change', document, {offset: 24})
        },
        onPin: () => {
            fire('sticky-sidebars::change', document, {offset: element.clientHeight + 24})
        },
    }).init()
})
